/***
 * 价格体系
 *  */
// 定制逻辑处理
export default {
  // 钢运物流价格体系
  gy_price_system: ["84139"], // 202509051247290736067
}
